import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// custom validator to check that two fields match

export function fieldsMustMatchValidator(matchTo): ValidatorFn | null {
  return (control: AbstractControl): ValidationErrors | null => {
    // Not working with input blur
    // if (control.errors && !control.errors.fieldsMustMatch) {
    // return if another validator has already found an error on the control
    // return;
    // }

    return control.value && control.value !== control.parent.controls[matchTo].value
      ? { fieldsMustMatch: false }
      : null;

    // return !!control.parent &&
    //   !!control.parent.value &&
    //   control.value === control.parent.controls[matchTo].value
    //   ? null
    //   : { fieldsMustMatch: false };
  };
}

// export function fieldsMustMatchValidator(matchTo): ValidationErrors | null {

// export function fieldsMustMatchValidator(controlName: string, matchingControlName: string) {
//   return (control: AbstractControl) => {
//     const field = control.get(controlName); // formGroup.controls[controlName];
//     const match = control.get(matchingControlName); // formGroup.controls[matchingControlName];

//     console.log('match errors: ', match.errors);

//     if (match.errors && !match.errors.fieldsMustMatch) {
//       // return if another validator has already found an error on the matchingControl
//       return;
//     }

//     if (field.value !== match.value) {
//       match.setErrors({ fieldsMustMatch: true });
//     }
//   };
// }

// , FormGroup
/* export function fieldsMustMatchValidator(controlName: string, matchingControlName: string) {
  // const validator: ValidatorFn = (formGroup: FormGroup) => {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.fieldsMustMatch) {
      // return if another validator has already found an error on the matchingControl
      return;
    }

    // set error on matchingControl if validation fails
    if (
      // control.value.length >= 6 &&
      // matchingControl.value.length >= 6 &&
      control.value !== matchingControl.value
    ) {
      matchingControl.setErrors({ fieldsMustMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}
 */

// field.length >= 6 && match.length >= 6 &&
